import { render } from "./ResumenBuscador.vue?vue&type=template&id=24f1e084&scoped=true"
import script from "./ResumenBuscador.vue?vue&type=script&lang=js"
export * from "./ResumenBuscador.vue?vue&type=script&lang=js"

import "./ResumenBuscador.vue?vue&type=style&index=0&id=24f1e084&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f1e084"]])

export default __exports__